import "./legal.css";
export default function Privacy() {
    return (
      <div className="legal-page">
        <h1>Privacy Policy</h1>
  
        <p>
          We respect your privacy. This game collects only the information
          necessary to provide core functionality such as authentication,
          matchmaking, and gameplay progression.
        </p>
  
        <p>
          Data collected may include usernames, guest identifiers, gameplay
          statistics, and technical information required to operate the service.
        </p>
  
        <p>
          Cookies may be used for authentication, analytics, and advertising
          purposes in accordance with applicable laws.
        </p>
  
        <p>
          We do not sell personal data to third parties.
        </p>
      </div>
    );
  }
  